import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Nav = () => {
    const location = useLocation();
    const pathName = location.pathname.split('-')[0];

    const menuItems = [
        {
            title: '회원관리',
            path: '/mabaa010',
            submenus: [
                {
                    title: '등록회원',
                    path: '/mabaa010',
                },
                {
                    title: '탈퇴회원',
                    path: '/mabaa020',
                },
            ],
        },
        {
            title: '채용관리',
            path: '/macaa010',
            submenus: [
                {
                    title: '등록승인',
                    path: '/macaa010',
                },
                {
                    title: '업계추정광고',
                    path: '/macaa020',
                },
            ],
        },
        {
            title: '이력서관리',
            path: '/madaa010',
            internalUrl: '/madaa020',
            submenus: [
                {
                    title: '인재정보',
                    path: '/madaa010',
                    internalUrl: '/madaa020',
                },
            ],
        },
        {
            title: '광고관리',
            path: '/maeaa010',
            internalUrl: '/maeaa020',
            submenus: [
                {
                    title: '광고관리',
                    path: '/maeaa010',
                    internalUrl: '/maeaa020',
                },
            ],
        },
        {
            title: '배너관리',
            path: '/mafaa030',
            submenus: [
                {
                    title: '배너상품',
                    path: '/mafaa030',
                },
                {
                    title: `비즈니스 배너`,
                    path: '/mafaa030',
                    space: 'space',
                },
                {
                    title: '그랜드 배너',
                    path: '/mafaa040',
                    space: 'space',
                },
                {
                    title: '프리미엄 배너',
                    path: '/mafaa050',
                    space: 'space',
                },
                {
                    title: '핫리쿠르트 배너',
                    path: '/mafaa060',
                    space: 'space',
                },
                {
                    title: '일반기업 배너',
                    path: '/mafaa070',
                    space: 'space',
                },

                {
                    title: '옵션상품',
                    path: '/mafaa080',
                },
                {
                    title: '고정 옵션',
                    path: '/mafaa080',
                    space: 'space',
                },
            ],
        },

        {
            title: '덴탈플러스',
            path: '/magab010',
            internalUrl: ['/magab020', '/magab030', '/magac020', '/magac040', '/magac050', '/magat020', '/magae020', '/magae030'],
            submenus: [
                {
                    title: '자원봉사',
                    path: '/magab010',
                    internalUrl: ['/magab020', '/magab030'],
                },
                {
                    title: '이벤트',
                    path: '/magac010',
                    internalUrl: ['/magac020', '/magac040', '/magac050'],
                },
                {
                    title: '법정의무교육',
                    path: '/magat010',
                    internalUrl: '/magat020',
                },
                {
                    title: '문서서식',
                    path: '/magad010',
                },
                {
                    title: '덴탈 매거진',
                    path: '/magae010',
                    internalUrl: ['/magae020', '/magae030'],
                },
            ],
        },
        {
            title: '고객센터',
            path: '/magah010',
            internalUrl: ['/magah020', '/magag020', '/magag030', '/magaf020', '/magaf030'],
            submenus: [
                {
                    title: '이메일 문의',
                    path: '/magah010',
                    internalUrl: '/magah020',
                },
                {
                    title: '자주 묻는 질문',
                    path: '/magag010',
                    internalUrl: ['/magag020', '/magag030'],
                },
                {
                    title: '공지/소식',
                    path: '/magaf010',
                    internalUrl: ['/magaf020', '/magaf030'],
                },
            ],
        },
        {
            title: '결제관리',
            path: '/maiaa010',
            submenus: [
                {
                    title: '이용권 관리',
                    path: '/maiaa010',
                },
                {
                    title: 'DVmall 사은품 교환목록',
                    path: '/maiab010',
                },
                {
                    title: '결제 취소 목록',
                    path: '/maiac010',
                },
            ],
        },
        {
            title: '통계관리',
            path: '/majaa010',
            submenus: [
                {
                    title: '일보고',
                    path: '/majaa000',
                },
                {
                    title: '매출내역관리',
                    path: '/majaa010',
                },
                {
                    title: '일별등록',
                    path: '/majab010',
                },
                {
                    title: '전체등록',
                    path: '/majac010',
                },
                {
                    title: '이용권등록',
                    path: '/majad010',
                },
                {
                    title: '무통장입금',
                    path: '/majad020',
                },
                {
                    title: '기타집계현황',
                    path: '/majad030',
                },
                {
                    title: '강조상품집계현황',
                    path: '/majad040',
                },
                {
                    title: '이니시스상점관리',
                    path: 'https://iniweb.inicis.com/security/login.do',
                    navigator: true,
                },
            ],
        },
        {
            title: '업무관리',
            path: '/magaa010',
            submenus: [
                {
                    title: '코드관리',
                    path: '/magaa010',
                },
                {
                    title: '관리자 계정관리',
                    path: '/maaaa000',
                },
                {
                    title: '상품관리',
                    path: '/maaaa001',
                },
            ],
        },
        // ,
        // {
        //     title: '마케팅 관리',
        //     path: '/BlankPage',
        //     submenus: [
        //         {
        //             title: '앱 설치 회원',
        //             path: '/BlankPage',
        //         },
        //         {
        //             title: 'PUSH 관리',
        //             path: '/BlankPage',
        //             thirdLevelMenus: [
        //                 { title: 'PUSH 발송내역', path: '/BlankPage' },
        //                 { title: 'PUSH 발송', path: '/BlankPage' },
        //             ],
        //         },
        //         {
        //             title: 'SMS관리',
        //             path: '/BlankPage',
        //             thirdLevelMenus: [
        //                 { title: 'SMS 발송내역', path: '/BlankPage' },
        //                 { title: 'SMS 발송', path: '/BlankPage' },
        //             ],
        //         },
        //     ],
        // },
    ];
    const isActiveLink = (mainMenu) => {
        // Kiểm tra đường dẫn chính
        if (location.pathname === mainMenu.path) return 'activeLink';

        // Kiểm tra submenu
        if (mainMenu.submenus) {
            const isSubmenuActive = mainMenu.submenus.some(
                (subMenu) =>
                    location.pathname === subMenu.path ||
                    (subMenu.thirdLevelMenus &&
                        subMenu.thirdLevelMenus.some((thirdMenu) => location.pathname === thirdMenu.path)),
            );

            return isSubmenuActive ? 'activeLink' : '';
        }

        return '';
    };
    return (
        <nav className="admin-navigation">
            <div className="container">
                <ul className="main-menu">
                    {menuItems.map((mainMenu, mainIndex) => (
                        <li
                            key={mainIndex}
                            className={`main-menu-item ${isActiveLink(mainMenu)} ${pathName === mainMenu?.url ||
                                (Array.isArray(mainMenu?.internalUrl)
                                    ? mainMenu.internalUrl.includes(pathName)
                                    : mainMenu?.internalUrl === pathName)
                                ? 'activeLink'
                                : ''
                                }`}
                        >
                            <NavLink
                                to={mainMenu.path}
                                className={`menu-item  ${pathName === mainMenu?.url ||
                                    (Array.isArray(mainMenu?.internalUrl)
                                        ? mainMenu.internalUrl.includes(pathName)
                                        : mainMenu?.internalUrl === pathName)
                                    ? 'activeLink'
                                    : ''
                                    }`}
                            >
                                {mainMenu.title}
                            </NavLink>
                            {mainMenu.submenus && (
                                <ul className="submenu">
                                    {mainMenu.submenus.map((subMenu, subIndex) => (
                                        <li
                                            key={subIndex}
                                            className={`submenu-item ${isActiveLink(subMenu)} ${subMenu.space ? 'space' : ''
                                                } 
                                            ${pathName === subMenu?.url ||
                                                    (Array.isArray(subMenu?.internalUrl)
                                                        ? subMenu.internalUrl.includes(pathName)
                                                        : subMenu?.internalUrl === pathName)
                                                    ? 'activeLink'
                                                    : ''
                                                }   `}
                                        >
                                            {subMenu.navigator ? (
                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        window.open(subMenu.path, '_blank');
                                                        e.preventDefault();
                                                    }}
                                                >
                                                    {subMenu.title}
                                                    {subMenu.thirdLevelMenus ? (
                                                        <i className="icon icon-arrow-right"></i>
                                                    ) : (
                                                        ''
                                                    )}
                                                </a>
                                            ) : (
                                                <NavLink to={subMenu.path}>
                                                    {subMenu.title}
                                                    {subMenu.thirdLevelMenus ? (
                                                        <i className="icon icon-arrow-right"></i>
                                                    ) : (
                                                        ''
                                                    )}
                                                </NavLink>
                                            )}
                                            {subMenu.thirdLevelMenus && (
                                                <ul className="third-level-menu">
                                                    {subMenu.thirdLevelMenus.map((thirdMenu, thirdIndex) => (
                                                        <li key={thirdIndex} className="third-level-menu-item">
                                                            <NavLink to={thirdMenu.path}>{thirdMenu.title}</NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default Nav;
